// Room around a clipping area for a focused control's ring (a 3px outline at a 3px offset): the
// area grows by this much on every side and gives it back with a negative margin, so the layout is
// unchanged but the ring isn't cut off.
$focus-room: 0.375rem;

.breadcrumbs {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* One line: crumbs shrink and truncate, and anything left over is clipped. */
.nowrap {
  flex-wrap: nowrap;
  overflow: hidden;
  margin: -$focus-room;
  padding: $focus-room;
}

.item {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
}

/* Tailwind's md and xl breakpoints. */
.hiddenBelowMd {
  @media (width < 48rem) {
    display: none;
  }
}

.hiddenBelowXl {
  @media (width < 80rem) {
    display: none;
  }
}

.link {
  display: inline-flex;
  min-width: 0;
  min-height: 1.5rem;
  align-items: center;
  color: var(--color-muted);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--color-primary);
  }
}

.separator {
  color: var(--color-muted);
  flex-shrink: 0;
}

.current {
  min-width: 0;
  margin: -$focus-room;
  padding: $focus-room;
  overflow: hidden;
  color: var(--color-text);
  text-overflow: ellipsis;
  white-space: nowrap;

  &[data-active="true"] {
    font-weight: 500;
  }
}

.backButton {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-muted);
  background: none;
  border: none;
  padding: 0;
  min-height: 1.5rem;
  cursor: pointer;
  transition: color 0.2s ease;
  text-decoration: none;

  &:hover {
    color: var(--color-primary);
  }
}
